<template>
  <div class="size-table">
    <h2>Размерная таблица</h2>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Размер</th>
            <th
              v-for="(header, index) in headers"
              :key="index"
            >
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in tableData" :key="index">
            <td class="size-col">{{ row.size }}</td>
            <td
              v-for="(header, hIndex) in headers"
              :key="hIndex"
            >
              {{ row.values[header] ?? '-' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Можно передавать данные таблицы через пропсы, если нужно
    tableData: {
      type: Array,
      required: true,
    }
  },
  computed: {
    headers() {
      const allKeys = new Set();
      this.tableData.forEach((row) => {
        Object.keys(row.values).forEach((key) => allKeys.add(key));
      });
      return Array.from(allKeys);
    }
  }
};
</script>


<style scoped>
.size-table {
  background: white;
  border-radius: 8px;
  padding: 16px;
  max-width: 100vw;  /* чтобы таблица не вылазила за экран */
  max-height: 80vh; /* ограничение по высоте */
  overflow: auto;   /* включаем свой скролл */
}

.size-table h2 {
  text-align: center;
  font-size: 1.4rem;
  margin-bottom: 12px;
}

.table-wrapper {
  overflow-x: auto; /* горизонтальный скролл при переполнении */
  border: 1px solid #ddd;
  border-radius: 8px;
}

table {
  width: 100%;
  min-width: 500px; /* чтобы таблица не сжималась слишком сильно */
  border-collapse: collapse;
  font-size: 0.95rem;
}

thead {
  background: #f2f2f2;
}

th, td {
  padding: 10px 14px;
  border: 1px solid #ddd;
  text-align: center;
  white-space: nowrap; /* чтобы текст не переносился */
}

tbody tr:nth-child(even) {
  background: #fafafa;
}

tbody tr:hover {
  background: #f5f5f5;
}

.size-col {
  font-weight: bold;
  color: #555;
}
</style>
